export default "__VITE_ASSET__CC$TrmL1__"